import * as React from "react";
const SvgCheckboxEmpty = (props) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 0.5, y: 0.5, width: 17, height: 17, rx: 4.5, stroke: "#6B7280" }));
export default SvgCheckboxEmpty;
